import $ from 'jquery'
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

const basicScrollTriggerConfig = (el) => ({
  trigger: el,
  pin: false,
  scrub: 1,
  markers: false
})

const onToggleAnimation = (el, disabled) => (self) => {
  if (self.isActive && !disabled) {
    el.addClass('in')
    self.disable()
    disabled = true
  } else {
    self.disable()
  }
}

function animateElements(selector, config) {
  $(selector).each(function () {
    const el = $(this)
    const disabled = false
    gsap.from(el, {
      scrollTrigger: {
        ...basicScrollTriggerConfig(el),
        ...config,
        onToggle: config.onToggle ? config.onToggle(el, disabled) : null
      }
    })
  })
}
function createScrollTrigger(triggerElement, timeline, start = "top 100%") {
  // Play timeline when scrolled into view (60% from the top of the screen)
  ScrollTrigger.create({
      trigger: triggerElement,
      start: start,
      onEnter: () => {
          timeline.play();
          console.log('element in');
      },
  });
}

function splitText() {
  $('[data-split="word"]').each(function () {
    // Get the text content of the element
    const text = $(this).text();

    // Split the text into words
    const words = text.split(' ');

    // Clear the original text content
    $(this).empty();

    // Append each word as a separate element
    words.forEach((word) => {
      $(this).append(`<span class="word">${word}&nbsp;</span>`);
    });
  });
}

function wordsSlideUp() {
  $('[data-split="word"]').each(function (index) {
    const tl = gsap.timeline({
      paused: true
    });
    let delay = $(this).attr('delay') ? $(this).attr('delay') : 0;
    let start = $(this).attr('start') ? $(this).attr('start') : 'top 90%';
    tl.from($(this).find(".word"), {
      y: '30px',
      opacity: 0,
      duration: 1.2,
      ease: "power4.out",
      delay: delay,
      stagger: {
        amount: 0.2
      }
    });
    createScrollTrigger($(this), tl, start);
  });
}

function appearence() {
  splitText();
  wordsSlideUp();

  animateElements('.animate', {
    start: 'top 100%',
    end: 'bottom 20%',
    onToggle: onToggleAnimation
  })

  animateElements('.animate-in-out', {
    start: 'top 100%',
    end: 'bottom bottom',
    toggleClass: 'active'
  })

  animateElements('.animate-now', {
    start: 'top bottom',
    end: 'bottom top',
    onToggle: onToggleAnimation
  })

  animateElements('.image-block-animation', {
    start: 'top bottom',
    end: 'bottom top',
    onToggle: onToggleAnimation
  })

}

function loaderInit() {

}

function pageTransitions() {
  $("a").on("click", function (e) {
    if ($(this).prop("hostname") === window.location.host &&
      $(this).attr("href").indexOf("#") === -1 &&
      $(this).attr("target") !== "_blank") {
      e.preventDefault();
      let destination = $(this).attr("href");


      gsap.to("#page-transition", {
        opacity: 1,
        duration: 0.5,
        onComplete: function () {
          window.location = destination;
        }
      });
    }
  });

  window.onpageshow = function (event) {
    if (event.persisted) {
      window.location.reload();
    }
  }
}

export { appearence, loaderInit, pageTransitions }
